import React, { useState } from 'react'
import { isLoaded, useFirebase, firestoreConnect } from 'react-redux-firebase'
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardText,
  Button,
  Spinner,
  Modal,
  ModalBody,
} from 'reactstrap'
import { Redirect, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
// import Checkbox from '@material-ui/core/Checkbox'

import moment from 'moment'
import 'moment/locale/fi'
import { Divider } from '@material-ui/core'
import PaymentRedirect from '../PaymentRedirect'
import PaymentOptions from '../PaymentOptions'
import { useEffect } from 'react'
import { compose } from 'redux'
import { useTranslation } from 'react-i18next'
import { useCookies } from 'react-cookie'
import withAppconfig from '../../AppContext'
import Payments from '../../components/Payments'
import { getWallet } from '../../components/ViewUtils'
import Giftcode from '../../components/Giftcode'
// import { getLastvalidDate } from './MembershipUtil'
import { Grid, Typography } from '@material-ui/core'
import Poster from '../../components/Poster'

const enhance = compose(
  connect((state) => ({ auth: state.firebase.auth })),
  firestoreConnect((props) => [
    {
      collection: 'users',
      doc: `${props.auth.uid}`,
      subcollections: [
        {
          collection: 'paymentinfo',
          doc: 'saldo',
          subcollections: [{ collection: `${props.appconfig.accountkey}` }],
        },
      ],
      storeAs: 'wallets',
    },
  ]),
  connect(
    (
      {
        payable: { selected },
        firebase: { auth, profile },
        firestore,
        globaltime: { gtime },
      },
      { appconfig }
    ) => {
      if (selected) {
        // console.log('selected', selected)
        const summary = { price: 0 }
        let wallet = []
        const walletName = getWallet(appconfig, summary)
        if (
          firestore.data['wallets'] &&
          firestore.data['wallets'][walletName]
        ) {
          wallet = firestore.data['wallets'][walletName]
        }
        const cashsum =
          wallet && wallet.cash
            ? wallet.cash.reduce((acc, curr) => {
                acc = acc + curr.amount
                return acc
              }, 0)
            : 0

        const sportmoneysum =
          wallet && wallet.sportmoney
            ? wallet.sportmoney.reduce((acc, curr) => {
                acc = acc + curr.amount
                return acc
              }, 0)
            : 0

        return {
          auth,
          profile,
          selected,
          summary,
          cashsum,
          sportmoneysum,
          wallet: firestore.data['wallets'] || [],
          memberships: [],
          gtime,
        }
      } else {
        return {
          auth,
          profile,
          selected,
          summary: {},
          cashsum: 0,
          sportmoneysum: 0,
          memberships: [],
          gtime,
        }
      }
    }
  )
)

function EventTicketVariation({ variations, ticketVariantAmounts, gtime }) {
  return (
    <Grid container spacing={2} style={{ marginTop: 20 }}>
      {variations.map((v) => {
        if (ticketVariantAmounts[v.id] === 0) {
          return null
        }
        if (v.earlybirdprice && v.earlybirddeadline && gtime.isBefore(moment(v.earlybirddeadline))) {
          v.price = v.earlybirdprice * 100
        }
        return (
          <React.Fragment key={v.id + '-fragment'}>
            <Grid item xs={5} key={v.id + '-name'}>
              <Typography
                variant='h6'
                component='span'
                style={{ marginRight: 10 }}
              >
                {v.name}
              </Typography>
            </Grid>
            <Grid item xs={3} key={v.id + '-price'}>
              <Typography
                variant='body1'
                component='span'
                style={{ marginRight: 10 }}
              >
                {ticketVariantAmounts[v.id] > 0
                  ? `${ticketVariantAmounts[v.id]} kpl`
                  : ''}{' '}
                {`(${(v.price / 100).toFixed(2).replace('.', ',')} €/kpl)`}
              </Typography>
            </Grid>
            <Grid
              item
              xs={4}
              key={`input-${v.id}`}
              style={{ textAlign: 'right' }}
            >
              {ticketVariantAmounts[v.id] > 0
                ? `${((v.price * ticketVariantAmounts[v.id]) / 100)
                    .toFixed(2)
                    .replace('.', ',')} €`
                : ''}
            </Grid>
            <Grid item xs={12} key={`divider-${v.id}`}>
              <Typography variant='caption' style={{ color: '#888' }}>
                {v.description || 'Ei lisätietoja'}
              </Typography>
              <Divider style={{ margin: '10px 0' }} />
            </Grid>
          </React.Fragment>
        )
      })}
    </Grid>
  )
}

const UNALLOWED_METHODS = [
  'cashier',
  'cashstore',
  'minutestore',
  'cashwallet',
  'benefitcard',
]

const EventTicketPaymentScreen = ({
  auth,
  profile,
  selected,
  summary,
  cashsum,
  sportmoneysum,
  wallet,
  dispatch,
  appconfig,
  memberships,
  gtime,
}) => {
  const firebase = useFirebase()
  let history = useHistory()
  let defaultLanguage = 'FI'
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  const [redirect, setRedirect] = useState(false)
  const [renderPayments, setRenderPayments] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useState(null)
  // const [payments, setPayments] = useState(null)
  const [errorNotification, setErrorNotification] = useState(null)
  const [onlinepaymentprovider, setOnlinePaymentProvider] = useState(null)
  const [initdone, setInitDone] = useState(false)
  // const [usernote, setUserNote] = useState(null)
  const [membershipprices, setMembershipPrices] = useState(null)
  const [giftcoderedeem, setGiftcoderedeem] = useState(null)
  const [pricescheck, setPricesCheck] = useState(false)

  console.log('selected', selected)
  console.log('memberships', memberships)

  // eslint-disable-next-line no-unused-vars
  const [cookies, setCookie] = useCookies(['selectedLanguage'])
  if (cookies.selectedLanguage) {
    defaultLanguage = cookies.selectedLanguage
  }
  // console.log('saldo', saldo, isLoaded(saldo))

  useEffect(() => {
    moment.locale(defaultLanguage.toLowerCase(), { week: { dow: 3 } })
  }, [defaultLanguage])
  const loaded = isLoaded(profile) && isLoaded(wallet) && selected

  if (loaded && !initdone) {
    setInitDone(true)
  }

  const goEventTickets = () => {
    dispatch({
      type: 'CLEAR_PAYABLE_EVENTTICKET',
      payload: null,
    })
    history.push(appconfig.pathPrefix + '/shop/tickets')
  }

  const setPaymentProvider = (p) => setOnlinePaymentProvider(p)

  const payTickets = async (selectedPayments) => {
    setLoading(true)
    const payableObject = {
      id: selected.id,
      customerid: appconfig.accountkey,
      paymentmethod: selectedPayments,
      ticketVariantAmounts: selected.ticketVariantAmounts,
      type: 'eventtickets',
    }
    if(selected.extraInfo && Object.keys(selected.extraInfo).length > 0) {
      payableObject.extraInfo = selected.extraInfo
    }
    console.log('payableObject', payableObject)

    if (giftcoderedeem) {
      payableObject.giftcode = giftcoderedeem
    }

    const shouldRenderOptions =
      selected.sumprice > 0
        ? selectedPayments.find((x) => x.type === 'online' && x.charged > 0)
        : false
    const shouldRedict =
      selected.sumprice > 0
        ? selectedPayments.find((x) => x.type === 'online' && x.charged > 0)
        : false
    firebase.functions().region = 'europe-west1'
    const fn = appconfig.istest ? 'testeventtickets-pay' : 'eventtickets-pay'
    const cardPayment = firebase.functions().httpsCallable(fn)
    try {
      let response = await cardPayment(payableObject)
      console.log('response', response)
      if (response.data.error || response.data.status === 'ERROR') {
        setLoading(false)
        const message = response.data.error || response.data.message
        setErrorNotification(message)
      } else if (shouldRenderOptions) {
        setRenderPayments(true)
      } else if (shouldRedict) {
        setRedirect(true)
      } else {
        setLoading(false)

        history.push(appconfig.pathPrefix + '/shop/eventtickets')
      }
    } catch (error) {
      alert(error.message)
      // console.log(error)
      setLoading(false)
    }
  }

  // const getNoteRow = () => {
  //   if (appconfig.activityextrafields) {
  //     return (
  //       <React.Fragment>
  //         <Divider />
  //         <Row className={'loose'}>
  //           <Col>
  //             <FormGroup className='loose-form'>
  //               <Label for='usernote'>{t('additionalinfo')}</Label>
  //               <Input
  //                 type='text'
  //                 name='usernote'
  //                 id='usernote'
  //                 value={usernote || ''}
  //                 placeholder=''
  //                 onChange={(event) => setUserNote(event.target.value)}
  //               />
  //             </FormGroup>
  //           </Col>
  //         </Row>
  //       </React.Fragment>
  //     )
  //   } else {
  //     return null
  //   }
  // }

  const updateItemPricing = (prices) => {
    if (prices && prices.length > 0) {
      prices.sort((a, b) => a.price - b.price)
    }
    let membershipids = memberships.map((v) => v.membershipid) //Object.keys(memberships || {}).map((key) => {
    //   return memberships[key].membershipid
    // })
    let _membershipprices = prices.filter((x) => {
      if (x.membershipid) {
        return membershipids.includes(x.membershipid)
      } else {
        return true
      }
    })
    // console.log('membershipprices', _membershipprices, 'selected', { ...selected })
    const originalPrice = selected.price
    if (_membershipprices && _membershipprices.length > 0) {
      selected.price = _membershipprices[0].price
    }
    if (_membershipprices.length > 0) {
      selected.overridecost = true
      const gen = {
        pricing: 'general',
        price: originalPrice,
      }
      _membershipprices.push(gen)
      // membershipprices.find((x) => x.pricing === 'general')
      // selected.general = gen
    }
    setMembershipPrices(_membershipprices)
  }

  const onValidGiftcode = (membershipprices, giftcode) => {
    setGiftcoderedeem(giftcode)
    updateItemPricing(membershipprices)
  }

  const cancelEntry = async (id) => {}

  if (!selected) {
    return <Redirect to='/' />
  }

  if (renderPayments) {
    return (
      <PaymentOptions
        selectedGw={'pc'}
        authorization={token}
        provider={onlinepaymentprovider}
        disabledmethods={appconfig.disabledpaymentmethods || []}
        onCancel={cancelEntry}
        cancellable={{ id: selected.id, type: 'eventtickets' }}
      />
    )
  } else if (redirect) {
    return <PaymentRedirect selectedGw={'pc'} authorization={token} />
  }

  if (!loaded) {
    return (
      <div className='full-page-background'>
        <Container className='login-dialog'>
          <Spinner /> Loading ...
        </Container>
      </div>
    )
  } else {
    // let lastvalidDate = getLastvalidDate(selected.validity, gtime)
    // if (lastvalidDate === 'permanent') {
    //   lastvalidDate = t('permanent')
    // } else {
    //   lastvalidDate = lastvalidDate.format('D.M.YYYY')
    // }

    if (
      !selected.ticketVariantAmounts ||
      Object.keys(selected.ticketVariantAmounts).length === 0
    ) {
      selected.ticketVariantAmounts = {}
    }
    if (selected.sumprice === undefined) {
      selected.sumprice = Object.keys(selected.ticketVariantAmounts).reduce(
        (acc, curr) => {
          const variant = selected.variations.find((v) => v.id === curr)
          if (!variant) {
            console.warn(
              `Variant with id ${curr} not found in selected variations`
            )
            return acc
          }
          if (variant.earlybirdprice && variant.earlybirddeadline) {
            variant.price = variant.earlybirdprice * 100
          }
          acc += selected.ticketVariantAmounts[curr] * variant.price
          return acc
        },
        0
      )
    }

    let unallowedmethods = UNALLOWED_METHODS
    // if (appconfig && appconfig.experimental && appconfig.experimental.paycardsfromsaldo) {
    //   unallowedmethods = ['cashier', 'cashstore', 'minutestore', 'benefitcard']
    // }

    return (
      <div className='full-page-background'>
        <Container className='login-dialog'>
          <Row>
            <Col md='8' className='mx-auto'>
              <Card>
                <CardHeader tag='h4'>{t('payment')}</CardHeader>
                <CardBody>
                  <Row className={'loose'}>
                    <Col style={{ textTransform: 'capitalize' }}>
                      <h5>{selected.displayName}</h5>
                    </Col>
                    <Col className={'text-right'}>
                      <Poster
                        data={selected.poster}
                        preferredSize={300}
                        alt={selected.displayName}
                        defaultBg={appconfig.logos}
                        // style={{ width: '100%' }}
                      />
                    </Col>
                  </Row>
                  <Divider style={{ marginTop: 10 }} />
                  {pricescheck ? (
                    <Spinner size='sm' />
                  ) : membershipprices ? (
                    membershipprices.map((p, i) => {
                      return (
                        <Row key={'membership-prices-' + i} className={'loose'}>
                          <Col>
                            {p.pricing === 'general' ? t('price') : p.pricing}
                          </Col>
                          <Col className={'text-right'}>
                            {i >= 1 ? (
                              <s>{p.price.toFixed(2).replace('.', ',')} €</s>
                            ) : (
                              p.price.toFixed(2).replace('.', ',') + ' €'
                            )}
                          </Col>
                        </Row>
                      )
                    })
                  ) : (
                    <Row className={'loose'} key={'price'}>
                      <Col xs={12}>
                        <EventTicketVariation
                          variations={selected.variations}
                          ticketVariantAmounts={selected.ticketVariantAmounts}
                          gtime={gtime}
                        />
                      </Col>

                      <Col>{t('price')}</Col>
                      <Col className={'text-right'}>
                        {(selected.sumprice / 100).toFixed(2).replace('.', ',')}{' '}
                        €
                      </Col>
                      <Col xs={12}>
                        <Typography variant='caption' style={{ color: '#888' }}>
                          {t('vat') + ' ' + selected.vat + ' %'}
                        </Typography>
                      </Col>
                      <Col xs={12}>
                        <Divider />
                        <Typography
                          variant='subtitle2'
                          style={{ marginTop: 5 }}
                        >
                          {t('eventticket_guidance')}
                        </Typography>
                      </Col>
                    </Row>
                  )}

                  <Divider />
                  <Row className={'loose'}>
                    <Col xs={4} sm={3}>
                      <Giftcode
                        selected={selected}
                        membershipprices={membershipprices}
                        pricesCheckState={setPricesCheck}
                        onValidGiftcode={onValidGiftcode}
                        producttype='activity'
                      />
                    </Col>
                  </Row>
                  <CardText></CardText>
                  <Payments
                    onlyfullpayment={true}
                    price={selected.sumprice / 100}
                    selecttype='payable'
                    unallowedmethods={unallowedmethods}
                    buttonText={
                      selected?.sumprice > 0 ? t('pay') : t('confirm')
                    }
                    buttonAction={payTickets}
                    errorNotification={errorNotification}
                    setPaymentProvider={setPaymentProvider}
                    ready={true}
                    nooverridemetohods={unallowedmethods}
                  />
                  <Button
                    size='small'
                    color='link'
                    className='text-muted'
                    onClick={() => goEventTickets()}
                  >
                    <ChevronLeftIcon /> {t('back_to_eventtickets')}
                  </Button>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal
          size='sm'
          centered
          isOpen={loading}
          backdrop={true}
          wrapClassName={'al-wrap'}
          modalClassName={'al-modal'}
          contentClassName={'loading-spinner'}
        >
          <ModalBody className='text-center'>
            <Spinner color='light' />{' '}
            <p style={{ color: 'white' }}>Vahvistetaan</p>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default withAppconfig(enhance(EventTicketPaymentScreen))
